export default function CsWifiAttacks() {
  return (
    <h2>Cs Wifi Attacks</h2>
  );
}
